import type { Verse } from '@quranjs/api';
import { createServerFn } from '@tanstack/react-start';

async function fetchAsset(path: string): Promise<Response> {
  const { env } = await import('cloudflare:workers');
  return env.ASSETS.fetch(new URL(path, 'http://localhost'));
}

export const getVersesByPage = createServerFn({ method: 'GET' })
  .inputValidator((pageNumber: string) => pageNumber)
  .handler(async ({ data: pageNumber }) => {
    const res = await fetchAsset(`/data/verses/${pageNumber}.json`);
    if (!res.ok) throw new Error('Failed to fetch verses by page.');
    return res.json() as Promise<Verse[]>;
  });

// Direct fetch for client-only code (spread mode useQuery). GET request to
// static JSON — cacheable by browser and future service worker.
export async function fetchVersesByPage(pageNumber: string): Promise<Verse[]> {
  const res = await fetch(`/data/verses/${pageNumber}.json`);
  if (!res.ok) throw new Error('Failed to fetch verses by page.');
  return res.json() as Promise<Verse[]>;
}
